import React from 'react';
import Icons from 'assets/icons';

interface ContentTypeItem {
  icon: React.ReactNode;
  type: string;
}

export const CONTENT_TYPES: ContentTypeItem[] = [
  {
    icon: <Icons.Articles customClass="w-4" />,
    type: 'Article',
  },
  {
    icon: <Icons.Guides customClass="w-4" />,
    type: 'Guide',
  },
  {
    icon: <Icons.Downloads customClass="w-4" />,
    type: 'Download',
  },
  {
    icon: <Icons.Webinars customClass="w-4" />,
    type: 'Webinar',
  },
  {
    icon: <Icons.ProductAnnouncements customClass="w-4" />,
    type: 'ProductAnnouncement',
  },
  {
    icon: <Icons.Glossary customClass="w-4" />,
    type: 'Glossary',
  },
];
